export default "__VITE_ASSET__CJztfQ9X__"